import {
    GetMfaApplicationsRequest,
    GetMfaApplicationsResponse,
    GetUserFactorsRequest,
    GetUserFactorsResponse,
    GetUserRequest,
    GetUserResponse,
    InitRequest,
    InitResponse,
    RestartOktaEnrollmentRequest,
    RestartOktaEnrollmentResponse,
    SearchUsersRequest,
    SearchUsersResponse,
    SetUserMfaApplicationRequest,
    SetUserMfaApplicationResponse
} from "./types";

export class ApiException {
    status: number;

    constructor(status: number) {
        this.status = status;
    }
}

export function init(request: InitRequest): Promise<InitResponse> {
    return doRequest('/api/mgmt/init', request);
}

export function searchUsers(request: SearchUsersRequest): Promise<SearchUsersResponse> {
    return doRequest('/api/mgmt/searchUsers', request);
}

export function getUser(request: GetUserRequest): Promise<GetUserResponse> {
    return doRequest('/api/mgmt/getUser', request);
}

export function setUserMfaApplication(request: SetUserMfaApplicationRequest): Promise<SetUserMfaApplicationResponse> {
    return doRequest('/api/mgmt/setUserMfaApplication', request);
}

export function restartOktaEnrollment(request: RestartOktaEnrollmentRequest): Promise<RestartOktaEnrollmentResponse> {
    return doRequest('/api/mgmt/restartOktaEnrollment', request);
}

export function getMfaApplications(request: GetMfaApplicationsRequest): Promise<GetMfaApplicationsResponse> {
    return doRequest('/api/mgmt/getMfaApplications', request);
}

export function getUserFactors(request: GetUserFactorsRequest): Promise<GetUserFactorsResponse> {
    return doRequest('/api/mgmt/getUserFactors', request);
}

function doRequest<T, U>(url: string, req: T): Promise<U> {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(req)
    }).then(res => {
        if (!res.ok) {
            throw new ApiException(res.status);
        }
        return res.json();
    }).then(res => {
        return res as U
    });
}
